import React from 'react';
import { find } from 'lodash';

import { ContactVm } from '@/types';
import { formatPhoneNumber } from '@/utils/format-phone-number';

import { AddressBlock } from '../AddressBook/components/Address/AddressBlock';
import { ContactAddress } from '../AddressBook/types';

import styles from './ShippingDetails.module.scss';

type Props = {
  selectedAddress: ContactVm | null;
  warehouseAddresses: ContactVm[];
  homeownerAddress: ContactVm;
  selectAddress: (address: ContactVm) => void;
  openAddressBook: () => void;
};

const getWarehouseToDisplay = (
  selectedAddress: ContactVm | null,
  allWarehouses: ContactVm[],
): ContactVm | null => {
  if (allWarehouses.length === 0) {
    return null;
  }

  const selectedWarehouse = find(allWarehouses, wa => wa.contactId === selectedAddress?.contactId);

  if (selectedWarehouse) {
    return selectedWarehouse;
  }

  const defaultWarehouse = find(allWarehouses, wa => wa.isDefault);

  if (defaultWarehouse) {
    return defaultWarehouse;
  }

  return allWarehouses[0];
};

export const ShippingDetails = (props: Props) => {
  const { selectedAddress, warehouseAddresses, homeownerAddress, selectAddress, openAddressBook } =
    props;

  const warehouseToDisplay = getWarehouseToDisplay(selectedAddress, warehouseAddresses);

  const warehouse: ContactAddress | null = warehouseToDisplay && {
    title: 'Warehouse',
    isDefault: warehouseToDisplay.isDefault,
    isSavedAddress: true,
    contact: {
      ...warehouseToDisplay,
      phoneNumber: formatPhoneNumber(warehouseToDisplay?.phoneNumber),
    },
  };

  const homeowner: ContactAddress = {
    title: `${homeownerAddress?.firstName} ${homeownerAddress?.lastName}`,
    isDefault: false,
    isSavedAddress: false,
    contact: {
      ...homeownerAddress,
      phoneNumber: formatPhoneNumber(homeownerAddress?.phoneNumber),
    },
  };

  const openModalButtonText = warehouse
    ? 'Use Different Saved Address'
    : 'No saved addresses, add one now';

  return (
    <div className={styles.address_wrapper}>
      <div className={styles.address_block_title}>Confirm shipping address</div>
      <div className={styles.address_content}>
        <div className={styles.cards_block}>
          <div className={styles.cards_wrapper}>
            {warehouse && (
              <AddressBlock
                address={warehouse}
                isSelected={selectedAddress?.contactId === warehouseToDisplay?.contactId}
                selectAddress={selectAddress}
              />
            )}
            <AddressBlock
              address={homeowner}
              isSelected={selectedAddress?.contactId === homeownerAddress.contactId}
              selectAddress={selectAddress}
            />
          </div>
          <div
            className={styles.view_address_book}
            data-testid="open-address-book-button"
            onClick={openAddressBook}
          >
            {openModalButtonText}
          </div>
        </div>
      </div>
    </div>
  );
};
